<template>
  <div id="workspace" class="mx-auto">
    <div class="mt-4" v-if="localSequence">
      <div class="mb-4 flex">
        <div class="flex header-sequence w-full">
          <div>
            <input 
              v-if="isSequenceNameEditing" 
              v-model="tempSequenceName" 
              @keydown.enter.prevent="saveSequenceNameEdit"
              @blur="saveSequenceNameEdit"
              class="sequence-name-input"
              ref="sequenceNameInput"
            />
            <h4 
              v-else 
              class="text mt-2 mr-4"
              @click="enableSequenceNameEditing"
            >
              {{selected_sequence.name}}
            </h4>
          </div>
          <vs-checkbox v-model="localSequence.repeat">Repeats</vs-checkbox>
        </div>
      </div>
      <div class="editable-text"></div>
      <div class="timeline">
        <div class="outer">
          <div :id="localSequence.trigger.id" class="trigger-card mb-5" @click.stop>
            <div class="info">
              <!-- <h3 class="title"></h3> -->
              <div class="timeline-info">
                <p class="font-semibold">Start when</p>
              </div>
              <v-select
                :clearable="false"
                v-model="localSequence.trigger.trigger_type"
                label="text"
                class="mb-2 w-full"
                :options="triggerTypeOptions"
              />
              <div v-if="localSequence.trigger.trigger_type.value == 'trigger_match_to_place'">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-checkbox class="mb-3 mt-3" v-model="localSequence.show_preview">Show Preview</vs-checkbox>
                  </div>
                  <div v-show="localSequence.show_preview" class="vx-col w-1/2">
                    <span>Preview Text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.preview_instructions_text" />
                  </div>
                  <div v-show="localSequence.show_preview" class="vx-col w-1/2">
                    <span>Preview Button Text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.preview_button_text" />
                  </div>
                  <div class="vx-col w-full">
                    <span>Instructions Text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.instructions_text" />
                  </div>
                  <div class="vx-col w-full">
                    <span>Instructions Button Text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.instructions_button_text" />
                  </div>
                </div>
              </div>

              <div v-if="localSequence.trigger.trigger_type.value == 'trigger_amqp_message_received'">
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <span>Host:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.host" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Port:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.port" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Username:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.username" />
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <span>Password:</span>
                    <vs-input class="w-full mb-2" v-model="localSequence.password" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>VirtualHost:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.virtual_host" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Exchange:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.exchange" />
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <span>Routing Key:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.routing_key" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>SelectedToken:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.selected_token" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Message:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.message" />
                  </div>
                </div>
              </div>
              <div v-if="localSequence.trigger.trigger_type.value == 'trigger_event_received'">
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <span>Type:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.event_type" />
                  </div>
                  <div class="vx-col w-2/3">
                    <span>Message:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.event_message" />
                  </div>
                </div>
              </div>
              <div v-if="localSequence.trigger.trigger_type.value == 'trigger_mqtt_message_received'">
                <div class="vx-row">
                  <div class="vx-col w-1/3">
                    <span>Host:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.host" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Username:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.username" />
                  </div>
                  <div class="vx-col w-1/3">
                    <span>Password:</span>
                    <vs-input class="w-full mb-2" v-model="localSequence.password" />
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col w-full">
                    <span>Read Topic:</span>
                    <vs-input class="w-full mb-2" name="name" v-model="localSequence.read_topic" />
                  </div>
                </div>
              </div>
              <div
                v-show="
                  localSequence.trigger.trigger_type.value == 'trigger_screen_tap' ||
                    localSequence.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                    localSequence.trigger.trigger_type.value == 'trigger_image_anchor_lost'
                "
              >
                <div v-show="localSequence.trigger.trigger_type.value != 'trigger_screen_tap'">
                  <span>Reference Image:</span>
                  <v-select
                    :clearable="false"
                    v-model="localSequence.anchor"
                    label="name"
                    class="mb-3 w-full"
                    :options="referenceImageOptions"
                  />
                </div>
                <div
                  v-if="
                    localSequence.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                    localSequence.trigger.trigger_type.value == 'trigger_screen_tap' ||
                    localSequence.trigger.trigger_type.value == 'trigger_user_aligned_anchor'
                  "
                >
                  <vs-checkbox class="mb-3" v-model="localSequence.show_instructions"
                    >Show instructions</vs-checkbox
                  >
                  <div v-if="localSequence.show_instructions">
                    <div v-if="localSequence.trigger.trigger_type.value == 'trigger_screen_tap'">
                    <span>Instructions image (optional):</span>
                    <file-pond
                      :imagePreviewHeight="200"
                      name="test"
                      ref="instructionImageFilePond"
                      :label-idle="this.$t('HoverpackImageDrag')"
                      :allow-multiple="false"
                      :instant-upload="false"
                      accepted-file-types="image/jpeg, image/png"
                      v-on:removefile="onInstructionImageRemoved"
                      v-on:addfile="onInstructionImageAdded"
                      v-on:init="onFilePondInit"
                    />
                  </div>
                  <span>Instructions text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.instructions_text" />
                    <!-- <span>Instructions text background</span>
              <vs-input
                class="w-full mb-3"
                placeholder="#000000"
                name="name"
                v-model="localSequence.instructions_text_background"
              /> -->
                  </div>
                </div>
              </div>
              <div
                v-show="
                  localSequence.trigger.trigger_type.value == 'trigger_user_aligned_anchor'
                "
              >
                  <span>Stencil</span>
                  <v-select
                    :clearable="false"
                    v-model="localSequence.anchor"
                    label="name"
                    class="mb-3 w-full"
                    :options="stencilOptions"
                  />
                <div
                  v-if="
                    localSequence.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                    localSequence.trigger.trigger_type.value == 'trigger_screen_tap' ||
                      localSequence.trigger.trigger_type.value == 'trigger_user_aligned_anchor'
                  "
                >
                  <vs-checkbox class="mb-3" v-model="localSequence.show_instructions"
                    >Show instructions</vs-checkbox
                  >
                  <div v-if="localSequence.show_instructions">
                    <span>Instructions text:</span>
                    <vs-input class="w-full mb-3" name="name" v-model="localSequence.instructions_text" />
                    <!-- <span>Instructions text background</span>
              <vs-input
                class="w-full mb-3"
                placeholder="#000000"
                name="name"
                v-model="localSequence.instructions_text_background"
              /> -->
                  </div>
                </div>
              </div>

              <div
                v-if="
                  localSequence.trigger.trigger_type.value == 'trigger_tap' ||
                    localSequence.trigger.trigger_type.value == 'trigger_enter_portal' ||
                    localSequence.trigger.trigger_type.value == 'trigger_exit_portal' ||
                    localSequence.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                    localSequence.trigger.trigger_type.value == 'trigger_proximity_exit' ||
                    localSequence.trigger.trigger_type.value == 'trigger_focus_in' ||
                    localSequence.trigger.trigger_type.value == 'trigger_focus_out'
                "
              >
                <span>Object(s):</span>
                <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
                <v-select
                  :clearable="false"
                  v-model="localSequence.targets"
                  multiple
                  label="text"
                  class="mb-2 w-full"
                  :options="nodePidHobjectNameOptions"
                  :key="localSequence.id + '-' + localSequence.trigger.trigger_type.value"
                />
              </div>
              <div
                v-if="
                  localSequence.trigger.trigger_type.value == 'trigger_match_to_place' ||
                    localSequence.trigger.trigger_type.value == 'trigger_tap_to_place'
                "
              >
                <span v-show="localSequence.trigger.trigger_type.value == 'trigger_match_to_place'"
                  >Object to use as stencil</span
                >
                <span v-show="localSequence.trigger.trigger_type.value == 'trigger_tap_to_place'"
                  >Object to use as reference (optional)
                </span>
                <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
                <v-select
                  v-model="localSequence.target"
                  label="text"
                  class="mb-2 w-full"
                  :options="nodePidHobjectNameOptions"
                  :key="localSequence.id + '-' + localSequence.trigger.trigger_type.value"
                />
              </div>
              <div
                v-if="
                  localSequence.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                    localSequence.trigger.trigger_type.value == 'trigger_proximity_exit'
                "
              >
                <span>Distance (meters):</span>
                <vs-input
                  min="0"
                  max="10000"
                  :step="1"
                  class="w-full mb-5"
                  v-model="localSequence.distance"
                  icon-inc="expand_less"
                  icon-dec="expand_more"
                />
              </div>
              <div
                v-if="
                  localSequence.trigger.trigger_type.value == 'trigger_collision_enter' ||
                    localSequence.trigger.trigger_type.value == 'trigger_collision_exit'
                "
              >
                <span>Between object:</span>
                <!-- Note: the :key in the v-select is only there to force refresh of internal state when changing trigger type -->
                <v-select
                  :clearable="false"
                  v-model="localSequence.monitored_object"
                  label="text" 
                  class="mb-2 w-full"
                  :options="nodePidHobjectNameOptions"
                  :key="localSequence.id + '-' + localSequence.trigger.trigger_type.value"
                />
                <span>And object(s):</span>
                <v-select
                  :clearable="false"
                  v-model="localSequence.targets"
                  multiple
                  label="text"
                  class="mb-2 w-full"
                  :options="nodePidHobjectNameOptions"
                  :key="localSequence.id + '-' + localSequence.trigger.trigger_type.value"
                />
              </div>
              <div
                v-if="
                  localSequence.trigger.trigger_type.value == 'trigger_tap' ||
                    localSequence.trigger.trigger_type.value == 'trigger_image_anchor_found' ||
                    localSequence.trigger.trigger_type.value == 'trigger_screen_tap' ||
                    localSequence.trigger.trigger_type.value == 'trigger_enter_portal' ||
                    localSequence.trigger.trigger_type.value == 'trigger_exit_portal' ||
                    localSequence.trigger.trigger_type.value == 'trigger_proximity_enter' ||
                    localSequence.trigger.trigger_type.value == 'trigger_proximity_exit'||
                    localSequence.trigger.trigger_type.value == 'trigger_collision_enter' ||
                    localSequence.trigger.trigger_type.value == 'trigger_collision_exit'||
                    localSequence.trigger.trigger_type.value == 'trigger_focus_in'||
                    localSequence.trigger.trigger_type.value == 'trigger_focus_out'
                "
              ></div>
            </div>
          </div>
          <draggable
            v-bind="dragOptions"
            :list="selected_actions"
            :actions="selected_actions"
            @change="onDragChange"
            @click.stop>
            <div
              v-for="action in selected_actions"
              :key="action.id"
              :name="action.id"
              :id="action.id"
              class="timeline-slot"
            >
              <sequence-element-card
                :action="action"
                :isSelected="selectedAction && selectedAction.id == action.id"
                :nodePidHobjectNameOptions="nodePidHobjectNameOptions"
                :referenceImageOptions="referenceImageOptions"
                :stencilOptions="stencilOptions"
                @remove="RemoveSequenceElement(action)"
                @duplicate="DuplicateSequenceElement(action)"
                @select="SelectSequenceElement(action.id, action)"
              />
            </div>
          </draggable>
        <sequence-elements-menu 
          :userRole="userRole" 
          :layerHomePageType="layerHomePageType"
          @action-selected="AddSequenceElement"
        />
      </div>
      </div>
    </div>
    <!-- Add this validation summary bar if there are validation errors -->
    <div v-if="totalValidationErrors > 0" class="validation-summary">
      <vs-icon icon="warning" color="warning" />
      <span>{{ totalValidationErrors }} issue{{ totalValidationErrors > 1 ? 's' : '' }} found in sequence</span>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import vSelect from 'vue-select'
import SequenceElementCard from './SequenceElementCard.vue';
import SequenceElementsMenu from './SequenceElementsMenu.vue';
import { getActionDescription, getActionClass, canTargetObjects, validateSequenceElement } from '../utils/sequence-element-utils';
import { createSequenceElement, duplicateAction } from '../utils/sequence-element-factory';
import * as HoverlayUtils from '@/assets/js/utils/hoverlay-utils.js'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'

// Import FilePond styles
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'

import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImageTransform from 'filepond-plugin-image-transform'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

import imageCompression from 'browser-image-compression'

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
  FilePondPluginImageExifOrientation,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginFileEncode
)
export default {
  name: 'SequenceWorkspace',
  
  components: {
    'v-select': vSelect,
    draggable,
    SequenceElementCard,
    SequenceElementsMenu,
  },
  
  props: {
    selected_sequence: {
      type: Object,
      default: null
    },
    triggerTypeOptions: {
      type: Array,
      default: () => []
    },
    nodePidHobjectNameOptions: {
      type: Array,
      default: () => []
    },
    referenceImageOptions: {
      type: Array,
      default: () => []
    },
    stencilOptions: {
      type: Array,
      default: () => []
    }
  },

  emits: [
    'update-sequence',
    'update-sequence-name',
    'sequence-element-selected',
    'sequence-element-added',
    'sequence-element-removed'
  ],
  
  data() {
    return {
      localSequence: null,
      isInternalChange: false, // Add this flag
      isSequenceNameEditing: false,
      tempSequenceName: '',
      selected_actions: [],
      selectedAction: null,
      userModifiedSequenceName: null, // Track user-modified sequence name
    };
  },
  computed: {
    userRole() {
      return HoverlayUtils.getUserRole()
    },
    layerHomePageType() {
      return HoverlayUtils.getLayerHomePageType()
    },
    // Add this computed property
    totalValidationErrors() {
      if (!this.selected_actions || !this.selected_actions.length) return 0;
      
      return this.selected_actions.reduce((count, action) => {
        const validation = validateSequenceElement(action);
        return count + (validation.isValid ? 0 : 1);
      }, 0);
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  
  watch: {
    selected_sequence: {
      handler(newSequence, oldSequence) {
        console.log('Before:', newSequence);

        this.localSequence = null;
        if (newSequence) {
          // Set flag to indicate this change is from prop update
          this.isInternalChange = true;

          // SOLUTION: Preserve both actions and name when updating the same sequence
          const isSameSequence = oldSequence && oldSequence.id === newSequence.id;
          const shouldPreserveActions = isSameSequence &&
                                        this.selected_actions.length > 0 &&
                                        (newSequence.actions.length === 0 ||
                                         newSequence.actions.length < this.selected_actions.length);

          // Check if we need to preserve the name (if user has explicitly modified it)
          const shouldPreserveName = isSameSequence &&
                                      this.userModifiedSequenceName &&
                                      this.userModifiedSequenceName !== newSequence.name;

          // Store the name to preserve before cloning - use the user-modified name
          const nameToPreserve = shouldPreserveName ? this.userModifiedSequenceName : null;

          // Clone the new sequence
          this.localSequence = JSON.parse(JSON.stringify(newSequence));

          // Apply preservations
          if (shouldPreserveActions) {
            // Keep existing actions, but update the sequence's actions to match
            this.localSequence.actions = [...this.selected_actions];
            console.log('Preserved actions during sequence update:', this.selected_actions.length, 'actions');
          } else {
            this.selected_actions = newSequence.actions;
          }

          if (shouldPreserveName && nameToPreserve) {
            // Keep the locally modified name
            this.localSequence.name = nameToPreserve;
            console.log('Preserved sequence name during trigger type change:', nameToPreserve);
          } else if (!isSameSequence) {
            // When switching to a different sequence, check if it has a custom name
            // (not matching the default pattern "Sequence X")
            const defaultNamePattern = /^Sequence \d+$/;
            if (newSequence.name && !defaultNamePattern.test(newSequence.name)) {
              this.userModifiedSequenceName = newSequence.name;
            }
          }

          console.log('After:', this.localSequence);

          // Reset flag after changes are made
          this.$nextTick(() => {
            this.isInternalChange = false;
          });
        } else {
          this.localSequence = null;
          this.userModifiedSequenceName = null;
        }

        // Reset editing state when switching sequences
        if (!oldSequence || !newSequence || oldSequence.id !== newSequence.id) {
          this.userModifiedSequenceName = null;
        }
        this.isSequenceNameEditing = false;
        this.tempSequenceName = '';
      },
      immediate: true
    },
    selected_action: function(updatedValue) {
      this.selected_action_clone = null
      // Clone selected_action in the next tick (to overcome vue-formulate issue)
      this.$nextTick(() => {
        this.selected_action_clone = JSON.parse(JSON.stringify(updatedValue))
      })
    },
    // Add watcher for trigger type changes to ensure actions are preserved
    'localSequence.trigger.trigger_type': {
      handler(newTriggerType, oldTriggerType) {
        if (newTriggerType && oldTriggerType &&
            newTriggerType.value !== oldTriggerType.value &&
            this.localSequence && this.selected_actions.length > 0) {
          // Trigger type changed - ensure we preserve actions in the sequence object
          this.localSequence.actions = [...this.selected_actions];
          console.log('Trigger type changed, preserved', this.selected_actions.length, 'actions');
        }
      },
      deep: true
    },
    localSequence: {
      handler(newValue) {
        // Only emit when change is from user action, not prop update
        if (newValue && !this.isInternalChange) {
          // Ensure the sequence object always has the latest actions and name before emitting
          if (this.selected_actions.length > 0) {
            newValue.actions = [...this.selected_actions];
          }
          // Name is already part of newValue, so no need to explicitly set it
          this.$emit('update-sequence', newValue);
        }
      },
      deep: true
    }
  },
  
  methods: {
    // Enable sequence name editing
    enableSequenceNameEditing() {
      if (!this.localSequence) return;
      
      this.tempSequenceName = this.localSequence.name;
      this.isSequenceNameEditing = true;
      
      // Focus the input on the next tick
      this.$nextTick(() => {
        if (this.$refs.sequenceNameInput) {
          this.$refs.sequenceNameInput.focus();
        }
      });
    },
    // Save sequence name edit
    saveSequenceNameEdit() {
      if (!this.localSequence) return;

      const cleanName = this.tempSequenceName.trim();
      if (cleanName) {
        // Track that the user has explicitly modified this sequence name
        this.userModifiedSequenceName = cleanName;
        this.localSequence.name = cleanName;
      }

      this.$emit('update-sequence-name', this.tempSequenceName.trim());

      this.isSequenceNameEditing = false;
      this.tempSequenceName = '';
    },
    
    // Update trigger properties
    updateTrigger(updatedTrigger) {
      if (!this.localSequence) return;
      
      this.localSequence.trigger = updatedTrigger;
    },

    showActionDuration(action) {
      var text = ''
      if (action.duration > 0) text += ` in ${action.duration}s`
      return text
    },

    showTriggerSubtitle(sequence) {
      if (!sequence.targets) return sequence.name
      var hobjectName = sequence.targets[0] ? sequence.targets[0].text : sequence.name
      var othersHobject = ''
      if (sequence.targets.length == 2) {
        othersHobject = `+ ${sequence.targets.length - 1} other `
      }
      if (sequence.targets.length > 2) {
        othersHobject = `+ ${sequence.targets.length - 1} others `
      }
      return `${hobjectName} ${othersHobject}`
    },

    showActionSubtitle(action) {
      return getActionDescription(action)
    },
    
    // Handle trigger type changes
    onTriggerTypeChanged({ triggerType, shouldRepeat }) {
      if (!this.localSequence) return;
      
      this.localSequence.repeat = shouldRepeat;
    },

    onInstructionImageRemoved: function (error, file) {
      if (!this.localSequence) return;
      this.localSequence.instructions_image_base64 = null;
    },

    async onInstructionImageAdded(error, file) {
      const resizeOptions = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 512,
        useWebWorker: true,
      }

      // Compress the image file and extract base64 string
      const compressedFile = await imageCompression(file.file, resizeOptions);
      const base64 = await imageCompression.getDataUrlFromFile(compressedFile)

      //Remove the mime type from the base64 string
      const finalBase64 = base64.split(',')[1];
      this.localSequence.instructions_image_base64 = finalBase64; 
    },

    onFilePondInit: function() {
      // Initialize filePong with the instruction image in base64
      if (this.localSequence.instructions_image_base64) {
        if (this.$refs.instructionImageFilePond) {
          this.$refs.instructionImageFilePond.addFile( "data:image/png;base64," + this.localSequence.instructions_image_base64)
        }
      }
    },

    // Handle selection
    SelectSequenceElement(actionId, action) {
      // Set the selected action locally if needed
      this.selectedAction = action;
      
      // Emit an event to notify the parent component
      this.$emit('sequence-element-selected', {
        actionId: actionId,
        action: action
      });
    },
    
    // Handle adding a new action to the sequence
    AddSequenceElement(actionType) {
      if (!this.localSequence) return;

      // Create a new action using the factory function
      const newAction = createSequenceElement(actionType);
      if (!newAction) return;
      // Set the action's start property based on the current state
      newAction.start = {
        value: this.selected_actions && this.selected_actions.length > 0 ? 'with_previous' : 'after_previous',
        text: this.selected_actions && this.selected_actions.length > 0 ? 'With Previous' : 'After Previous'
      };
      
      // Add the new action to the actions array
      if (Array.isArray(this.selected_actions)) {
        this.selected_actions.push(newAction);
      }
      
      // Emit an event to notify the parent component about the new element
      this.$emit('sequence-element-added', {
        action: newAction,
        sequenceId: this.localSequence.id
      });
      
      // Select the newly added action
      this.$nextTick(() => {
        this.SelectSequenceElement(newAction.id, newAction);
      });
    },

    RemoveSequenceElement(action) {
      if (!this.selected_actions) return;
      
      // Find the index of the action to remove
      const index = this.selected_actions.findIndex(a => a.id === action.id);
      
      // If found, remove it from the array
      if (index !== -1) {
        this.selected_actions.splice(index, 1);
      }

      // Make sure the the first element in the sequence is "after_previous"
      if (this.selected_actions.length > 0) {
        this.selected_actions[0].start = {
          value: 'after_previous',
          text: 'After Previous'
        }
      }
      
            // Emit an event to notify the parent component about the removal
      this.$emit('sequence-element-removed', {
        actionId: action.id,
        sequenceId: this.localSequence.id
      });
    },

    DuplicateSequenceElement(action) {
      if (!this.selected_actions || !action) return;

      // Use the duplicateAction function from the factory
      const duplicatedAction = duplicateAction(action);
      if (!duplicatedAction) return;

      // Find the index of the original action
      const originalIndex = this.selected_actions.findIndex(a => a.id === action.id);

      // Insert the duplicated action right after the original
      if (originalIndex !== -1) {
        this.selected_actions.splice(originalIndex + 1, 0, duplicatedAction);
      } else {
        // If not found, add to the end
        this.selected_actions.push(duplicatedAction);
      }

      // Emit an event to notify the parent component about the duplication
      this.$emit('sequence-element-added', {
        action: duplicatedAction,
        sequenceId: this.localSequence.id
      });

      // Select the newly duplicated action
      this.$nextTick(() => {
        this.SelectSequenceElement(duplicatedAction.id, duplicatedAction);
      });
    },

    onDragChange(event) {
      // Emit sequence update when drag and drop order changes
      if (event.moved) {
        console.log('Action order changed via drag and drop');
        // Update the sequence with the new action order and emit change
        if (this.localSequence) {
          this.localSequence.actions = [...this.selected_actions];
          this.$emit('update-sequence', this.localSequence);
        }
      }
    }
  },
  
  // Cleanup timeout when component is destroyed
  beforeUnmount() {
    if (this.updateSequenceTimeout) {
      clearTimeout(this.updateSequenceTimeout);
    }
  }
};
</script>

<style lang="scss" scoped>
#workspace {
  position: relative;
  height: 95vh;
  overflow-y: auto;
  margin: 0 auto;
  padding: 20px 20px 20px 420px;
  flex: 1;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center; /* Center children horizontally */
}

.timeline {
  position: relative;
  padding: 0 0 0 26px;
  counter-reset: timeline-counter;
  min-height: 10vh;
  max-width: 800px; /* Control maximum width */
  width: 100%; /* Take available space up to max-width */
}

.timeline .outer {
  margin: 0 auto;
  width: 100%;
}

#selected_sequence\\.trigger\\.id {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  margin: 0 auto;
  padding: 6px 15px;
  border-radius: 8px;
  border-left: 3px solid #5B3CC4;
  border: 2px solid #5B3CC4;
  background-color: rgba(91, 60, 196, 0.04);
  max-width: 800px; /* Match timeline max-width */
  width: 100%;
}

.header-sequence {
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 6px;
  width: 2px;
  background-color: #d1d1d1;
  z-index: 0;
}

.timeline-slot {
  position: relative;
}

.timeline-slot:has(.after-previous) {
  position: relative;
  margin-top: 8px;
}

.timeline-slot:has(.after-previous)::before {
  content: counter(timeline-counter);
  counter-increment: timeline-counter;
  position: absolute;
  top: 50%;
  left: -19px;
  width: 20px;
  height: 20px;
  background-color: white;
  border: 2px solid rgba(var(--vs-primary), 0.7);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  color: rgba(var(--vs-primary), 0.9);
}

/* Distinctive Trigger Card styling */
.trigger-card {
  position: relative;
  margin: 0 0 15px 0;
  padding: 15px 15px 15px 20px;
  background: linear-gradient(to right, rgba(248, 186, 11, 0.08), rgba(248, 186, 11, 0.03));
  border-radius: 12px;
  box-shadow: 0 3px 8px rgba(248, 186, 11, 0.15);
  border: 2px dotted #f8ba0b;
  border-left: 6px solid #f8ba0b;
  
  /* Add awaiting label */
  &::after {
    content: "TRIGGER";
    position: absolute;
    top: -10px;
    right: 20px;
    background-color: #f8ba0b;
    color: white;
    font-size: 10px;
    font-weight: bold;
    padding: 4px 10px;
    border-radius: 10px;
    letter-spacing: 1px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  /* Style the title area */
  .timeline-info {
    position: relative;
    margin-bottom: 12px;
    
    p {
      color: #b18208;
      font-weight: 600;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      
      &::before {
        content: "⟳"; /* Clock/loop symbol */
        display: inline-block;
        margin-right: 8px;
        font-size: 32px;
        color: #f8ba0b;
      }
    }
  }
  
  /* Style the dropdown and form elements inside trigger */
  .vs-select {
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 6px;
  }
  
  .vs-checkbox {
    margin-top: 10px;
  }
}

/* Update the "0" counter styling for trigger */
#selected_sequence\\.trigger\\.id::before {
  content: "0";
  position: absolute;
  top: 24px;
  left: -6px;
  width: 24px;
  height: 24px;
  background-color: #f8ba0b;
  border: 2px solid white;
  border-radius: 50%;
  transform: translateX(-50%);
  z-index: 2;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 0 0 4px rgba(248, 186, 11, 0.3);
}

.trigger-card::before {
  background-color: #f8ba0b;
  border-color: white;
  transform: translate(-50%, -50%);
}

.card::before {
  display: none;
}

.with-previous {
  position: relative;
  margin-top: 0px !important;
  margin-left: 20px;
  border-left: 3px solid rgba(var(--vs-primary), 0.7);
  padding-left: 10px;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.with-previous + .with-previous {
  border-top: none;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: -1px;
}

.after-previous + .with-previous {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-top: 1px solid #eaeaea;
}

.with-previous:not(:has(+ .with-previous)) {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 1px solid #eaeaea;
}

.timeline-slot:has(.with-previous) {
  margin-top: -1px;
  position: relative;
}

.timeline-slot:has(.with-previous) + .timeline-slot:has(.with-previous) .with-previous {
  border-top: 0;
  box-shadow: none;
}

.timeline-slot:has(.with-previous)::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -12px;
  width: 5px; 
  background-color: rgba(var(--vs-primary), 0.5);
  border-radius: 2px;
}

.timeline-slot:has(.after-previous) + .timeline-slot:has(.with-previous)::after {
  content: "";
  position: absolute;
  top: -35%;
  bottom: 0;
  left: -12px;
  width: 5px;
  background-color: rgba(var(--vs-primary), 0.5);
  border-radius: 2px;
}

.timeline-slot:has(.after-previous) + .timeline-slot:has(.with-previous) .after-previous {
  border-left: 3px solid rgba(var(--vs-primary), 0.2);
  padding-left: 10px;
}

.icon-size > i {
  font-size: 1.6rem;
}

.action-type-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 0px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: white;
}

.action-type-icon > i {
  font-size: 1rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
}

.round-icon {
  border-radius: 50%;
  background-color: rgba(var(--vs-primary), 1);
}

.empty-state {
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  margin: 2rem 0;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

h4 {
  cursor: text;
  
  &:hover {
    text-decoration: underline;
  }
}

/* Validation summary styling */
.validation-summary {
  position: sticky;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 800px;
  background-color: rgba(255, 186, 0, 0.1);
  border: 1px solid rgba(255, 186, 0, 0.5);
  border-radius: 8px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 10;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  margin-top: 15px;
  margin-bottom: 15px;
  
  i {
    font-size: 20px;
  }
  
  span {
    font-weight: 500;
    color: #b17800;
  }
}
</style>